module.exports = __webpack_public_path__ + "img/beapayday-powered-by-footer.6b18ca67.png";